<template>
<div style="height:auto;" >
  <iframe id="bdIframe" style="width:100%; height:100%" :src="src" width="100%" height="100%"  frameborder="false" ></iframe>
</div>
</template>

<script>
// // @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Doc',
  data(){
    return {
      src: 'http://www.geecity.com/index.php?case=archive&act=list&catid=1' 
    }
  },
  mounted(){
    /**
     * iframe-宽高自适应显示   
     */
    const oIframe = document.getElementById('bdIframe');
    const deviceWidth = document.documentElement.clientWidth;
    const deviceHeight = document.documentElement.clientHeight;
    oIframe.style.width = (Number(deviceWidth)-50) + 'px'; //数字是页面布局宽度差值
    oIframe.style.height = (Number(deviceHeight)-120) + 'px'; //数字是页面布局高度差
  },
  components: {
    // HelloWorld
  }
}
</script>
<style scoped lang="scss">
html,
body {
  /*设置内部填充为0，几个布局元素之间没有间距*/
  padding: 0px;
  /*外部间距也是如此设置*/
  margin: 0px;
  /*统一设置高度为100%*/
  height: 100%;
}
</style>